import React from 'react';
import InputFileUpload from '../common/UploadForm';
import InputFileDownload from '../common/DownloadForm';


export default function Attachment(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketForm = props.ticketForm

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Adjunto</p>
        </div>

        <div className='tkt-form-section-item'>
          {(action === 'create') && (
            <InputFileUpload
              name={'attachment'}
              handleSelection={handleSelection}
            />
          )}
          {(action === 'view') && (
            <InputFileDownload
              path={ticketForm.attachment}
            />
          )}
        </div>
      </div>

    </React.Fragment>
  );
}
